<div class="centered-content">
  @if (call.minutesGenerationProgress !== null) {
    @let progress = call.minutesGenerationProgress;
    <app-progress-loader class="minutes-progress" [value]="progress" loading></app-progress-loader>
    @if (call.minutesGenerationTemplateProgress; as tp) {
      <span class="loading-text">{{
        'CALLS.MINUTES_TEMPLATE_ITEM_PROGRESS_WITH_PERCENTAGE' | translate: { level: tp.level, index: tp.index, total: tp.total, progress }
      }}</span>
    } @else {
      <span class="loading-text">{{ 'CALLS.MINUTES_PROCESSING_MESSAGE' | translate }} ({{ progress }}%)</span>
    }
  } @else {
    <app-progress-loader class="minutes-progress" indeterminate></app-progress-loader>
    @if (call.minutesGenerationTemplateProgress; as tp) {
      <span class="loading-text">{{ 'CALLS.MINUTES_TEMPLATE_ITEM_PROGRESS' | translate: { level: tp.level, index: tp.index, total: tp.total } }}</span>
    } @else {
      <span class="loading-text">{{ 'CALLS.MINUTES_PROCESSING_MESSAGE' | translate }}</span>
    }
  }
</div>
